<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="700"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-tabs v-model="tab">
            <v-tab>Setting</v-tab>
            <v-tab>Trucks</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>

                  <v-col>
                    <v-text-field

                        v-model="selectedObject.name"
                        class="dialog-input"
                        hide-details
                        label="ชื่อ channel"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                  </v-col>

                </v-row>


              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col>
                    <div style="max-height: calc(90vh - 250px);overflow: scroll">
                    <v-treeview
                        v-model="selectedObject.stream_trucks_id"
                        :items="trucks"
                        selectable
                    >
                    </v-treeview>
                    </div>


                  </v-col>
                </v-row>
              </v-container>

            </v-tab-item>
          </v-tabs-items>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบ notify
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <Menu :drawerWidth="drawer_width"></Menu>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการช่อง line notify
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'ชื่อ', value: 'name' },
                        { text: 'สถานะ', value: 'enabled' ,width: '120px', fixed: true },
                        { text: 'ลิ้ง Report', value: 'report', width: '120px', fixed: true },
                        { text: 'ลิ้ง Telegram', value: 'line', width: '120px', fixed: true },
                        { text: 'แก้ไข', value: 'edit', width: '80px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editObject"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>

            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.name }}

              <v-btn v-if="item.telegram_channel_id==null || item.telegram_channel_id==''"
                     class="ml-1 red pa-1 caption" style="color: white" x-small>

                ยังไม่ได้ลิ้ง telegram
              </v-btn>




            </template>
            <template v-slot:item.report="{ item }">
              <a @click.stop="$root.$emit('openQr',{name:`QR ${item.name}`,url:`https://liff.line.me/2002541495-ZnkOkWz3?route=shipping_report&id=${item.id}`})">ลิ้ง Report</a>
            </template>
            <template v-slot:item.line="{ item }">
              <a target="_blank" :href="'/telegram/request/'+item.id">ลิ้ง Telegram</a>
            </template>
          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newObject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}

.tab-item {
  min-height: 360px;
}

</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {Truck} from '@/models/Truck'
import {LineStream, LineStreamConst} from '@/models/LineStream'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy, Menu}
})
export default class ViewAdminLineStream extends Vue {
  tab = null
  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: LineStream[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: LineStream | null = null

  LineStreamConst = LineStreamConst


  trucks: Truck[] = []

  async editObject(object: LineStream) {
    this.objectLoading = true

    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = new LineStream()
      this.selectedObject = await (new LineStream()).load<LineStream>(object.id)
    }

    this.objectLoading = false

  }


  newObject() {
    this.selectedObject = new LineStream()
    this.selectedObject.enabled = true
    this.EditObjectDialog = true

  }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, LineStream.prototype)

    if (this.selectedObject) {
      try {
        let object = await this.selectedObject.save<LineStream>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})


        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      } catch (e) {
        this.$root.$emit('onError', {error: e})
      }
      this.objectLoading = false
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, LineStream.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    this.refreshLineStream().then(() => {
    })
    this.refreshTrucks().then(() => {
    })


  }

  async refreshLineStream() {
    const url = Helper.setting.line_stream.getListAPI

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
      console.log(this.objects)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.objectsLoading = false
  }

  async refreshTrucks() {
    const url = Helper.setting.truck.getListAPI

    try {
      this.trucks = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
      this.trucks = this.trucks.map(t=>{return <Truck>{...t,name:`${t.name} ${t.plate??''}`}});

    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.objectsLoading = false
  }

}
</script>
